/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { OAuthClientDetailsPage } from '@/pages/OAuthClients/OAuthClientDetailsPage';

export function OAuthClientDetailsRoute() {
  return <OAuthClientDetailsPage />;
}
